import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { filterNulls } from 'dibs-ts-utils/exports/filterNulls';
import RailItemsContainer from './RailItemsContainer';
import RailShopAllLink from './RailShopAllLink';
import RailThumbnailLink from './RailThumbnailLink';

import { RailTag_tag$key } from './__generated__/RailTag_tag.graphql';

type Props = {
    tag: RailTag_tag$key | null;
};

const RailTag: FC<Props> = ({ tag: tagRef }) => {
    const tag = useFragment(
        graphql`
            fragment RailTag_tag on TradePhotoTag {
                name
                similarItems {
                    searchUrl
                    category {
                        name
                        parent {
                            label
                        }
                    }
                    items {
                        localizedPdpUrl
                        title
                        photos(limit: 1) {
                            versions {
                                webPath
                            }
                        }
                    }
                }
            }
        `,
        tagRef
    );

    const similarItems = tag?.similarItems;
    const category = similarItems?.category;
    const l2CategoryLabel = category?.parent?.label || '';
    const titleText = category?.name || tag?.name || '';
    const items = similarItems?.items || [];

    if (!items.length) {
        return null;
    }

    const links = items.filter(filterNulls).map((item, index) => {
        const title = item.title || '';
        const pdpURL = item.localizedPdpUrl || '';
        const dataTn = `rail-tag-item-${pdpURL}-${index}`;
        return (
            <RailThumbnailLink
                key={pdpURL}
                dataTn={dataTn}
                href={pdpURL}
                title={title}
                clickTrackingLabel={l2CategoryLabel}
                imgSrc={item.photos?.[0]?.versions?.[0]?.webPath || ''}
            />
        );
    });

    return (
        <RailItemsContainer
            items={links}
            creatorLink={
                <RailShopAllLink
                    href={similarItems?.searchUrl || ''}
                    clickTrackingLabel={l2CategoryLabel}
                    creatorName={titleText}
                />
            }
        />
    );
};

export default RailTag;
